var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isBusy)?_c('div',[_c('b-skeleton-img')],1):_c('div',[_c('apexchart',{key:_vm.componentKey,attrs:{"width":_vm.chartWidth,"height":_vm.height,"type":"bar","options":_vm.barChartOptions,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }